<template>
  <model-form
    ref="modelForm"
    :model="studio"
    modal-type="modal"
  >
    <div class="column">
      <div class="row q-col-gutter-x-sm items-center">
        <model-form-input
          field="name"
          class="col-9"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
        />
        <model-form-input
          field="abbreviation"
          class="col-3"
          label="Abbreviation"
          maxlength="4"
          bottom-slots
        />
      </div>
      <div class="row q-col-gutter-x-sm items-center">
        <model-form-select
          field="boxOfficeWeekDefaultStartDay"
          class="col-6"
          label="Box Office Week Start (Default)"
          :options="$constants.dayOfWeekNumbers"
          map-options
          emit-value
        >
          <q-tooltip>
            The default start day for the box office week. Used when creating new movies.
            <br>Does not affect existing movies.
          </q-tooltip>
        </model-form-select>
        <model-form-toggle
          field="boxOfficeWeekDefaultExtendPremieres"
          class="col-6 q-pb-md"
          label="Box Office Week Extend Premieres (Default)"
        >
          <q-tooltip>
            The default setting for whether to extend the box office week to include premieres.
            <br>Used when creating new movies. Does not affect existing movies.
          </q-tooltip>
        </model-form-toggle>
      </div>
      <div class="row q-col-gutter-x-sm items-center">
        <model-form-toggle
          field="hasRetentionFee"
          class="col-6 q-pb-md"
          label="Has Retention Fee"
        >
          <q-tooltip>Retain a portion of rental fees for associated payments.</q-tooltip>
        </model-form-toggle>
        <model-form-input
          field="retentionFeePercentHundredths"
          class="col-6"
          label="Retention Fee"
          suffix=" %"
          type="number"
          value-type="Number"
          step="0.01"
          min="0"
          max="100"
          :disable="!studio.hasRetentionFee"
          :decode="val => val / 100.0"
          :encode="val => Math.min(Math.max(val, 0), 100) * 100"
          :rules="[
            val => !$_.isNil(val) || 'Field is required',
            val => val >= 0 || 'Value must be greater than or equal to 0',
            val => val <= (100 * 100) || 'Value must be less than or equal to 100'
          ]"
        >
          <q-tooltip>Percentage of rental fees retained for other payments.</q-tooltip>
        </model-form-input>
      </div>
      <div class="row q-col-gutter-x-sm items-center">
        <model-form-toggle
          field="sendRentrak"
          class="col-12 q-pb-md"
          label="Include in Box Office Reports (Comscore, Numero, etc.)"
        >
          <q-tooltip>
            Send Box Office data to third party EBORs, including Rentrak Flash, Maccsbox, and Numero.
          </q-tooltip>
        </model-form-toggle>
      </div>
      <div class="row q-col-gutter-x-sm items-center">
        <model-form-toggle
          field="reportBySwiftEbor"
          class="col-6 q-pb-md"
          label="Report by SWIFT eBOR"
        />
        <model-form-toggle
          field="autoSendSwiftEbor"
          class="col-6 q-pb-md"
          label="Auto Send SWIFT eBOR"
          :disable="!studio.reportBySwiftEbor"
        />
      </div>
      <div class="row q-col-gutter-x-sm items-center">
        <model-form-toggle
          field="reportByEmail"
          class="col-6 q-pb-md"
          label="Report by Email"
        />
        <model-form-toggle
          field="autoSendEmail"
          class="col-6 q-pb-md"
          label="Auto Send Email"
          :disable="!studio.reportByEmail"
        />
        <model-form-toggle
          field="reportBoxOfficeDaily"
          class="col-6 q-pb-md"
          label="Report Daily"
          :disable="!studio.reportByEmail"
        >
          <q-tooltip>
            Email weekly box office report to Studio daily, until the box office week has concluded.
          </q-tooltip>
        </model-form-toggle>
        <model-form-toggle
          field="useEmailSummary"
          class="col-6 q-pb-md"
          label="Send Summaries"
          :disable="!studio.reportByEmail"
        >
          <q-tooltip>
            Send a collated summary of all ready to send box office reports instead of individual box office report emails to the studio.
          </q-tooltip>
        </model-form-toggle>
        <template v-if="studio.reportByEmail && studio.useEmailSummary">
          <model-form-toggle
            field="showIndividualBoxOfficeReporting"
            class="col-6 q-pb-md"
            label="Show All Reports"
          >
            <q-tooltip>
              Show individual box office reports in the emailed summary (appended after the summarised report data).
            </q-tooltip>
          </model-form-toggle>
          <model-form-toggle
            field="showRentalReporting"
            class="col-6 q-pb-md"
            label="Show Rental Fees"
          >
            <q-tooltip>
              Show box office rental fees in the summarised box office report.
            </q-tooltip>
          </model-form-toggle>
        </template>
        <model-form-input
          field="reportingEmail"
          class="col-12"
          label="Reporting Email"
          :disable="!studio.reportByEmail"
          :rules="[isValidEmailAddresses]"
          hint="Multiple email addresses must be separated by commas"
        />
      </div>
    </div>
  </model-form>
</template>

<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'StudioForm',
  components: {
    ModelForm
  },
  models: {
    studio: 'default'
  },
  methods: {
    isValidEmailAddresses (val) {
      if (!this.studio.reportByEmail) {
        return true
      } else if (!val) {
        return 'Field is required'
      }

      const spaceDelimitedRegex = /\w\s+\w/
      if (spaceDelimitedRegex.test(val)) {
        return 'Multiple email addresses must be separated by commas'
      }

      return true
    }
  }
}

</script>
